<template>
  <div id="">
    <div class="level-right" style="margin-bottom: 10px;">
        <div class="level-item">
            <b-field grouped group-multiline>
                <b-select v-model="selectedUser" :expanded="true">
                    <option value="">-- All Users --</option>
                    <option :key="id" :value="user.email" v-for="(user, id) in allUsers">
                        {{ user.displayName}} ({{ user.email }})
                    </option>
                </b-select>
            </b-field>
        </div>
        <div class="level-item">
            <b-field grouped group-multiline>
                <b-select v-model="perPage" :disabled="!isPaginated">
                    <option value="1000">All</option>
                    <option value="5">5 per page</option>
                    <option value="10">10 per page</option>
                    <option value="15">15 per page</option>
                    <option value="20">20 per page</option>
                </b-select>
            </b-field>
        </div>
    </div>

    <b-table
        :data="myDownloadFiles"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :default-sort-direction="defaultSortDirection"
        default-sort="timeCreated"
        :opened-detailed="defaultOpenedDetails"
        :loading="isLoading"
        detailed
        detail-key="id"
    >

        <template slot-scope="props">
            <b-table-column field="id" label="ID" :visible="false">
                {{ props.row.id }}
            </b-table-column>

            <b-table-column field="fileName" label="File Name" sortable>
                <a :href="props.row.downloadUrl" target="_blank">
                    {{ props.row.originalFile }}
                </a>
            </b-table-column>

            <b-table-column field="timeCreated" label="Creation Date" sortable centered>
                <span class="tag is-default">
                    {{ new Date(props.row.timeCreated).toLocaleDateString() }}
                </span>
            </b-table-column>

            <b-table-column field="timeExpired" label="Expiration Date" sortable centered>
                <span class="tag is-default">
                    {{ new  Date(props.row.timeExpired).toLocaleDateString() }}
                </span>
            </b-table-column>

            <b-table-column field="fileExt" label="Type" sortable right>
                <span class="tag is-default">
                    {{ props.row.fileExt }}
                </span>
            </b-table-column>

            <b-table-column field="size" label="Size" sortable numeric>
                <span class="tag" style="background-color: initial;">
                    {{ Math.ceil(props.row.size / 1000) }}KB
                </span>
            </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
            <article class="media">
                <figure class="media-left">
                    <p class="image is-96x96">
                        <img :src="'/static/img/icons/512px/' + props.row.fileExt.toLowerCase() +'.png'" :alt="props.row.fileName">
                    </p>
                </figure>
                <div class="media-content">
                    <div class="content">

                            <h4 class="title is-4" style="margin-top: 0; margin-bottom: 5px;">
                                <a :href="props.row.downloadUrl" target="_blank">
                                    {{ props.row.originalFile }}
                                </a>
                                <small>
                                    (<a :href="props.row.downloadUrl" target="_blank">{{ props.row.fileName }}</a>)
                                </small>
                            </h4>


                            <em>
                                Uploaded By
                                    <img :src="props.row.photoURL"  v-if="props.row.photoURL" alt="" class="img-circle" width="16"> <strong>{{ props.row.displayName }}</strong>
                                    <small>{{ props.row.timeCreated | ago }}</small>
                            </em>

                        <p>
                            <em v-html="newline_to_br(props.row.notes)"></em>
                        </p>
                    </div>
                </div>
            </article>
        </template>

        <template slot="empty">
            <b-table-column field="fileName" label="File Name"></b-table-column>
            <b-table-column field="timeCreated" label="Creation Date"></b-table-column>

            <b-table-column field="timeExpired" label="Expiration Date"></b-table-column>

            <b-table-column field="fileExt" label="Type"></b-table-column>

            <b-table-column field="size" label="Size"></b-table-column>

            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p>There are no recent files.</p>
                </div>
            </section>
        </template>
    </b-table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['isAdmin', 'files', 'users', 'isLoading'],
  data() {
      return {
          downloadFiles: [],
          sortColumn: 'timeCreated',
          sortOrder: 'desc',
          user: {},
          selectedUser: '',
          progress: 0,
          isPaginated: true,
          defaultSortDirection: 'desc',
          currentPage: 1,
          perPage: 1000,
          defaultOpenedDetails: [],
      }
  },
    computed: {
        allUsers: function () {
            return _.reject(this.users, function(u,i) {
                return !u.email;
            });
        },
        myDownloadFiles: function () {
            let that = this
            this.downloadFiles = _.map(this.files, function(o, i) {
                o.timeExpired = moment(o.timeCreated).add(60, 'days').toISOString();
                o.id = ++i;
                o.displayName = o.fullPath ? o.fullPath.split('/')[1] : 'Unknown';
                o.photoURL = '';
                return o;
            });

            // filter by email address
            this.downloadFiles = _.filter(this.downloadFiles, function(o, i) {
                if (!that.selectedUser) {
                    return o;
                }
                let email = o.fullPath ? o.fullPath.split('/')[1] : '';
                return email == that.selectedUser;
            });

            // expand details if it has notes
            this.defaultOpenedDetails = _.map(_.filter(this.downloadFiles, 'notes'), 'id');

            return _.orderBy(this.downloadFiles, [this.sortColumn], [this.sortOrder]);
        },
    },
  watch: {
      perPage: function (val) {
        this.isPaginated = (val == 0 ? false : true);
      }
  },
  methods: {
    newline_to_br: function (str) {
      if (!str) {
        return 'No Description'
      }
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  },
  filters: {
      date: function(time) {
          if (time === null) {
              time = 0;
          }

          return moment(time).format('MM/DD/YYYY');
      },
      ago: function(time) {
          if (time === null) {
              time = 0;
          }

          return moment(time).fromNow();
      },
      capitalize: function (value) {
        return _.capitalize(value);
      }

  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// AdminDownloadTable.vue?69a9e2d8